__turbopack_context__.v({
  "dialog": "index-module-scss-module__gy1jAG__dialog",
  "message": "index-module-scss-module__gy1jAG__message",
  "title": "index-module-scss-module__gy1jAG__title",
});
